import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmptyStateController from 'components/EmptyStateController';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Button from 'components/Button';
import Flex from 'components/Flex';
import HintTooltip from 'components/HintTooltip';
import useModalQueryParam from 'hooks/useModalQueryParam';
import useUniqueId from 'hooks/useUniqueId';
import { useFetchUserEmails, useDeleteUserEmail, useResendUserEmailVerification } from 'actions/userEmails';
import EmailListItem from 'components/AdditionalEmails/EmailListItem';
import DeleteEmailConfirmationModal from 'components/AdditionalEmails/DeleteEmailConfirmationModal';
import AddEmailModal from './AddEmailModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function UserEmailsContent() {
  var _data$additionalEmail;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchUserEmails = useFetchUserEmails(),
    data = _useFetchUserEmails.data,
    isLoading = _useFetchUserEmails.isLoading,
    isError = _useFetchUserEmails.isError;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    emailPendingDelete = _useState2[0],
    setEmailPendingDelete = _useState2[1];
  var additionalEmailsLabelId = useUniqueId();
  var primaryEmailsLabelId = useUniqueId();
  var _useModalQueryParam = useModalQueryParam('add-email'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasAddEmailModal = _useModalQueryParam2[0],
    toggleAddEmailModal = _useModalQueryParam2[1];
  var _useResendUserEmailVe = useResendUserEmailVerification(),
    resendUserEmailVerification = _useResendUserEmailVe.resendUserEmailVerification,
    isResending = _useResendUserEmailVe.isPending,
    resendingEmailId = _useResendUserEmailVe.variables;
  var _useDeleteUserEmail = useDeleteUserEmail(),
    deleteUserEmail = _useDeleteUserEmail.deleteUserEmail,
    isDeleting = _useDeleteUserEmail.isPending;
  var sortedEmails = _toConsumableArray((_data$additionalEmail = data === null || data === void 0 ? void 0 : data.additionalEmails) !== null && _data$additionalEmail !== void 0 ? _data$additionalEmail : []).sort(function (a, b) {
    return a.email.localeCompare(b.email);
  });
  var existingEmails = data ? [data.primaryEmail].concat(_toConsumableArray(data.additionalEmails.map(function (_ref) {
    var email = _ref.email;
    return email;
  }))) : [];
  return /*#__PURE__*/_jsxs(EmptyStateController, {
    isLoading: isLoading,
    isError: isError,
    data: data,
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "s",
      children: [/*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Flex, {
          justifyContent: "space-between",
          align: "center",
          mb: "xs",
          children: /*#__PURE__*/_jsxs(Flex, {
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              bold: true,
              id: primaryEmailsLabelId,
              children: t('email_settings_primary_email_label')
            }), /*#__PURE__*/_jsx(HintTooltip, {
              content: t('email_settings_primary_email_hint'),
              id: primaryEmailsLabelId,
              spacingLeft: "xxs"
            })]
          })
        }), data !== null && data !== void 0 && data.primaryEmail ? /*#__PURE__*/_jsx(Flex, {
          background: "shaded",
          grow: true,
          borderRadius: "large",
          px: "s",
          py: "xs",
          children: /*#__PURE__*/_jsx(Text, {
            bold: true,
            overflow: "wrap",
            children: data === null || data === void 0 ? void 0 : data.primaryEmail
          })
        }) : /*#__PURE__*/_jsx(Text, {
          dimmed: true,
          children: t('amount_none')
        })]
      }), /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Flex, {
          justifyContent: "space-between",
          align: "center",
          mb: "xs",
          children: [/*#__PURE__*/_jsxs(Flex, {
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              bold: true,
              id: additionalEmailsLabelId,
              children: t('email_settings_additional_emails_label')
            }), /*#__PURE__*/_jsx(HintTooltip, {
              content: t('email_settings_additional_emails_hint'),
              id: additionalEmailsLabelId,
              spacingLeft: "xxs"
            })]
          }), /*#__PURE__*/_jsx(Button, {
            size: "medium",
            onClick: toggleAddEmailModal,
            icon: "plus",
            children: t('actions_add_email')
          })]
        }), sortedEmails.length ? /*#__PURE__*/_jsx(Stack, {
          spacing: "xs",
          children: sortedEmails.map(function (userEmail) {
            return /*#__PURE__*/_jsx(EmailListItem, {
              userEmail: userEmail,
              isResending: isResending && resendingEmailId === userEmail.id,
              onResend: resendUserEmailVerification,
              onRemove: function onRemove() {
                return setEmailPendingDelete(userEmail);
              },
              resendHint: t('hint_resend_verification_email'),
              resendHintDisabled: t('hint_resend_verification_email_disabled')
            }, userEmail.id);
          })
        }) : /*#__PURE__*/_jsx(Text, {
          dimmed: true,
          children: t('amount_none')
        })]
      })]
    }), hasAddEmailModal && /*#__PURE__*/_jsx(AddEmailModal, {
      existingEmails: existingEmails,
      onClose: toggleAddEmailModal
    }), emailPendingDelete && /*#__PURE__*/_jsx(DeleteEmailConfirmationModal, {
      emailId: emailPendingDelete.id,
      email: emailPendingDelete.email,
      onClose: function onClose() {
        return setEmailPendingDelete(null);
      },
      onConfirm: deleteUserEmail,
      isPending: isDeleting,
      description: t('modal_delete_additional_email_body')
    })]
  });
}
export default UserEmailsContent;